
/** 数字金额大写转换(可以处理整数,小数,负数) */
export const digitUppercase = function (n) {
    var fraction = ['角', '分'];
    var digit = [
        '零', '壹', '贰', '叁', '肆',
        '伍', '陆', '柒', '捌', '玖'
    ];
    var unit = [
        ['元', '万', '亿'],
        ['', '拾', '佰', '仟']
    ];
    var head = n < 0 ? '欠' : '';
    n = Math.abs(n);
    var s = '';
    for (var i = 0; i < fraction.length; i++) {
        s += (digit[Math.floor(n * 10 * Math.pow(10, i)) % 10] + fraction[i]).replace(/零./, '');
    }
    s = s || '整';
    n = Math.floor(n);
    for (var i = 0; i < unit[0].length && n > 0; i++) {
        var p = '';
        for (var j = 0; j < unit[1].length && n > 0; j++) {
            p = digit[n % 10] + unit[1][j] + p;
            n = Math.floor(n / 10);
        }
        s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s;
    }
    return head + s.replace(/(零.)*零元/, '元')
        .replace(/(零.)+/g, '零')
        .replace(/^整$/, '零元整');
}

//转为千分位
export const comdify = function (s, key) {
    return s
    //去除首位输入的0，如002，小数不影响parseFloat字符串转数字
    // if(!s) return false
    // s=s.toString();  
    // if(s==''){
    // 	return '';
    // }else{
    // 	s = s.replace(/^(\d*)$/, "$1.");  
    // 	s = (s + "00").replace(/(\d*\.\d\d)\d*/, "$1");  
    // 	s = s.replace(".", ",");  
    // 	var re = /(\d)(\d{3},)/;  
    // 	while (re.test(s))  
    // 		s = s.replace(re, "$1,$2");  
    // 	s = s.replace(/,(\d\d)$/, ".$1"); 
    // 	return data.extraInfo[key] = s.replace(/^\./, "0.");    
    // }                  
}

export const comdifyth = function (s) {
    //去除首位输入的0，如002，小数不影响parseFloat字符串转数字
    s = s.toString();
    if (s == '') {
        return '';
    } else {
        s = s.replace(/^(\d*)$/, "$1.");
        s = (s + "000").replace(/(\d*\.\d\d\d)\d*/, "$1");
        s = s.replace(".", ",");
        var re = /(\d)(\d{3},)/;
        while (re.test(s))
            s = s.replace(re, "$1,$2");
        s = s.replace(/,(\d\d\d)$/, ".$1");
        return s.replace(/^\./, "0.");
    }
}

export const AgentClearNoNum = function (obj) {
    if (obj) {
        obj = obj.replace(/[^\d.]/g, "");
        obj = obj.replace(/^\./g, "");
        obj = obj.replace(/\.{2,}/g, ".");
        obj = obj.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
        obj = obj.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); //只能输入两个小数
    }
    console.log(obj)
    return obj
}

export const checknum = function (obj, key) {
    console.log(key)
    if (obj) {
        obj = obj.replace(/[^\d.]/g, "");
        obj = obj.replace(/^\./g, "");
        obj = obj.replace(/\.{2,}/g, ".");
        obj = obj.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
        obj = obj.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); //只能输入两个小数
        this.form.extraInfo[key] = obj
    }
}

export const check_list = function (obj, key, list, index) {
    if (obj) {
        // if(!(Number(obj)>0)){
        // 	Vue.prototype.$Message.error("金额要大于0");
        // 	this.form[list][index][key] = ''
        // 	return;
        // }
        if (!/^(([1-9]\d*|[1-9]\d{0,2}(,\d{3})*)|(0))(\.(\d){1,2})?$/.test(obj)) {
            Vue.prototype.$Message.error("金额小数不能超过两位");
            this.form[list][index][key] = Number(obj).toFixed(2)
            return;
        }
    }
}

export const checknum_list = function (obj, key, list, index) {
    if (obj) {
        obj = obj.replace(/[^\d.]/g, "");
        obj = obj.replace(/^\./g, "");
        obj = obj.replace(/\.{2,}/g, ".");
        obj = obj.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
        obj = obj.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); //只能输入两个小数
        this.form[list][index][key] = obj
    }
}

export const checknum_list_rate = function (obj, key, list, index) {
    if (obj) {
        obj = obj.replace(/[^\d.]/g, "");
        obj = obj.replace(/^\./g, "");
        obj = obj.replace(/\.{2,}/g, ".");
        obj = obj.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
        obj = obj.replace(/^(\-)*(\d+)\.(\d\d\d\d\d).*$/, '$1$2.$3'); //只能输入五个小数
        this.form[list][index][key] = obj
    }
}

export const clearNoNum_rate = function (obj, key) {
    if (obj) {
        obj = obj.replace(/[^\d.]/g, "");
        obj = obj.replace(/^\./g, "");
        obj = obj.replace(/\.{2,}/g, ".");
        obj = obj.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
        obj = obj.replace(/^(\-)*(\d+)\.(\d\d\d\d\d).*$/, '$1$2.$3'); //只能输入三个小数
        this.form.extraInfo[key] = obj
    }
}

export const clearNoNum = function (obj, key) {
    if (obj) {
        obj = obj.replace(/[^\d.]/g, "");
        obj = obj.replace(/^\./g, "");
        obj = obj.replace(/\.{2,}/g, ".");
        obj = obj.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
        obj = obj.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3');
        this.form.extraInfo[key] = obj
    }
}


export const clearNoNum_list = function (obj, key, list, index) {
    if (obj) {
        obj = obj.replace(/[^\d.]/g, "");
        obj = obj.replace(/^\./g, "");
        obj = obj.replace(/\.{2,}/g, ".");
        obj = obj.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
        obj = obj.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3');
        this.form[list][index][key] = obj
    }
}

export const checkyzbm = function (obj, key) {
    if (obj) {
        obj = obj.replace(/[^\d.]/g, ""); //清除"数字"和"."以外的字符
        obj = obj.replace(/^\./g, ""); //验证第一个字符是数字
        obj = obj.replace(/\.{2,}/g, "."); //只保留第一个, 清除多余的
        obj = obj.replace(/^[0-9][0-9]{6}$/g, "");
        obj = obj.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
        obj = obj.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); //只能输入两个小数
        this.form.extraInfo[key] = obj
    }
}
export const NumFormatInt = function (value) {
    if (!value) return '0';
    value = Number(value).toFixed(0);
    value = value + '';
    // let intPart = Number(value).toFixed(0); //获取整数部分
    let intPart = Math.floor(value); //获取整数部分
    let intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,'); //将整数部分逢三一断

    // let floatPart = ".00"; //预定义小数部分
    // let value2Array = value.split(".");

    //=2表示数据有小数位
    // if(value2Array.length == 2) {
    //     floatPart = value2Array[1].toString(); //拿到小数部分

    //     if(floatPart.length == 1) { //补0,实际上用不着
    //         return intPartFormat + "." + floatPart + '0';
    //     } else {
    //         return intPartFormat + "." + floatPart;
    //     }

    // } else {
    return intPartFormat
    // }
}
// 获取元素到body距离
export const offSet = function (curEle) {
    var totalLeft = null;
    var totalTop = null;
    var par = curEle.offsetParent;
    //首先把自己本身的相加
    totalLeft += curEle.offsetLeft;
    totalTop += curEle.offsetTop;
    //现在开始一级一级往上查找，只要没有遇到body，我们就把父级参照物的边框和偏移相加
    while (par) {
        if (navigator.userAgent.indexOf("MSIE 8.0") === -1) {
            //不是IE8我们才进行累加父级参照物的边框
            totalTop += par.clientTop;
            totalLeft += par.clientLeft;
        }
        //把父级参照物的偏移相加
        totalTop += par.offsetTop;
        totalLeft += par.offsetLeft;
        par = par.offsetParent;
    }
    return totalTop
}

// 页面滑动到form校验未通过的地方
export const handleErrorScrollTop = function () {
    setTimeout(() => {
        let hasTime = 0
        var isError = document.getElementsByClassName("ivu-form-item-error");
        let top = offSet(isError[0]) - 50
        let timer = setInterval(() => {
            document.documentElement.scrollTop += -50
            hasTime = hasTime + 1
            if (document.documentElement.scrollTop <= top || hasTime > 50) {
                clearInterval(timer)
            }
        }, 10);
    }, 0)
}

// 根据产品code跳转对应url
export const getAgentUrl = function (data) {
    let url = ''
    if (!data) return url
    if (data.productCode == 'OLD_INSURANCE_PROXY_BUSINESS_PROPERTY') url = '/agent.html#/agent/bizprop-alyone/'
    if (data.productCode == 'OLD_INSURANCE_PROXY_MACHINE_DAMAGE') url = '/agent.html#/agent/machdmg-alyone/'
    if (data.productCode == 'OLD_INSURANCE_PROXY_PRODUCT_LIABILITY_FOREIGN') url = '/agent.html#/agent/opro-alyone/'
    if (data.productCode == 'OLD_INSURANCE_PROXY_PRODUCT_LIABILITY_INLAND') url = '/agent.html#/agent/productins-alyone/'
    if (data.productCode == 'OLD_INSURANCE_PROXY_SPECIAL_THIRD') url = '/agent.html#/agent/spcleqpt-alyone/'
    if (data.productCode == 'OLD_INSURANCE_PROXY_OVERSEAS_TRAVELERS') url = '/agent.html#/agent/tourins-alyone/'
    if (data.productCode == 'OLD_INSURANCE_PROXY_YACHT') url = '/agent.html#/agent/yacht-alyone/'
    if (data.productCode == 'OLD_INSURANCE_PUBLIC_LIABILITY_INSURANCE') url = '/agent.html#/agent/public-alyone/'
    return url + data.insuranceApplicationId
}

// 获取服务商列表
export const getCustomerList = function (vue) {
    return new Promise((resolve, reject) => {
        let params = {
            page: 1,
            count: 999,
            bizId: 'OLD_INSURANCE_PROXY'
        }
        vue.$axios.post('/broker/enterprise/list.admin.json', params).then(res => {
            resolve(res)
        })
    })
}

// 提交表单统一处理
export const submitForm = function (vue, data) {
    return new Promise((resolve, reject) => {
        // if (data.insureAttachAmount>0) data.extraInfo.insureAttachAmount=data.insureAttachAmount
        // if (data.insureMainAmount>0) data.extraInfo.insureMainAmount=data.insureMainAmount
        // if (data.insureSumAmount>0) data.extraInfo.insureSumAmount=data.insureSumAmount
        // if (data.insureSumPay>0){
        // 	data.extraInfo.insureSumPay=data.insureSumPay
        // }
        // return
        // data.extraInfo.insureAttachAmountCap = data.insureAttachAmountCap?data.insureAttachAmountCap:data.extraInfo.insureAttachAmountCap

        // data.extraInfo.insureMainAmountCap = data.insureMainAmountCap?data.insureMainAmountCap:data.extraInfo.insureMainAmountCap

        // data.extraInfo.insureSumAmountCap = data.insureSumAmountCap?data.insureSumAmountCap:data.extraInfo.insureSumAmountCap

        // data.extraInfo.insureSumPayCap = data.insureSumPayCap?data.insureSumPayCap:data.extraInfo.insureSumPayCap


        // if (!data.extraInfo.insureAttachAmount)data.extraInfo.insureAttachAmount=0

        if (JSON.stringify(data.beneficiaryList[0]) == '{}') delete data.beneficiaryList
        if (JSON.stringify(data.applicantList[0]) == '{}') delete data.applicantList
        if (JSON.stringify(data.insuredList[0]) == '{}') delete data.insuredList

        if (data.productCode == 'OLD_INSURANCE_PROXY_SPECIAL_THIRD') {
            //特种设备第三者责任险特殊处理
            if (data.insuredList) {
                data.insuredList.forEach(el => {
                    el.contactName = data.contactName
                    el.contactPhone = data.contactPhone
                    el.address = data.address
                    el.zipCode = data.zipCode
                })
            }
        } else {
            data.extraInfo.detailList = []
            if (data.mainList) data.extraInfo.detailList.push(...data.mainList)
            if (data.addList) data.extraInfo.detailList.push(...data.addList)
        }
        if (data.productCode == 'OLD_INSURANCE_PROXY_YACHT') { //游艇险
            // 数组转字符串
            if (data.extraInfo.paymentAgree) data.extraInfo.paymentAgree = data.extraInfo.paymentAgree.join(',')
            if (data.extraInfo.specialAgree) data.extraInfo.specialAgree = data.extraInfo.specialAgree.join(',')
        }
        if (data.productCode == 'OLD_INSURANCE_PROXY_PRODUCT_LIABILITY_INLAND') { //国内产品责任险
            // 数组转字符串
            if (data.extraInfo.proAttachedData) data.extraInfo.proAttachedData = data.extraInfo.proAttachedData.join(',')
            if (data.extraInfo.paymentAgree) data.extraInfo.paymentAgree = data.extraInfo.paymentAgree.join(',')
        }
        if (data.productCode == 'OLD_INSURANCE_PROXY_PRODUCT_LIABILITY_FOREIGN') { //海外产品责任险
            // 数组转字符串
            if (data.extraInfo.proAttachedData) data.extraInfo.proAttachedData = data.extraInfo.proAttachedData.join(',')
        }

        data.premium = data.extraInfo.insureSumPay ? data.extraInfo.insureSumPay : data.premium
        data.insureAmount = data.extraInfo.insureSumAmount ? data.extraInfo.insureSumAmount : data.insureAmount
        if (!data.insuranceType) data.insuranceType = 'NEW'
        if (data.insuranceType == 'NEW') data.lastYearPolicyNo = ''
        delete data.mainList
        delete data.addList
        delete data.customerList
        // 受益人处理
        if (data.beneficiaryList && data.everyAddress) {
            data.beneficiaryList.forEach(el => {
                el.address = data.everyAddress || ''
            })
        }
        if (data.productCode == 'OLD_INSURANCE_PROXY_OVERSEAS_TRAVELERS') { //境外旅行人身意外伤害险
            if (data.insuredList && data.insuredList[0]) {
                if (data.insuredList[0].subjectName || data.insuredList[0].idNumber ||
                    data.insuredList[0].gender || data.insuredList[0].birthday ||
                    data.insuredList[0].contactPhone || data.insuredList[0].contactEmail) {
                    data.insuredList[0].subjectType = 'INSURED'
                } else {
                    delete data.insuredList
                }
            }
        }
        vue.$axios.post('/broker/insurance/application/draft.json', data).then(res => {
            resolve(res)
        })
    })
}

// 查看投保单详情统一处理
export const DetailForm = function (vue, id,dst = false) {
    return new Promise((resolve, reject) => {
        let url = '/broker/insurance/application/detail'
        if(dst){
            url = url + '.dst'
        }
        vue.$axios.post(url, { applicationId: id }).then(res => {
            console.log(res)
            if (res.extraInfo) {
                if (res.extraInfo && typeof res.extraInfo == 'string') {
                    res.extraInfo = JSON.parse(res.extraInfo)
                }
                if (res.extraInfo.detailList) {
                    // 主险，附加险数据处理
                    let list = res.extraInfo.detailList
                    let mainList = []
                    let addList = []
                    list.forEach(el => {
                        if (el.isMain == 1) mainList.push(el)
                        if (el.isMain == 0) addList.push(el)
                    })
                    res.mainList = mainList
                    res.addList = addList
                    res.mainList.forEach(el => {
                        for (let key in el) {
                            el[key] = el[key].toString()
                        }
                    })
                    res.addList.forEach(el => {
                        for (let key in el) {
                            el[key] = el[key].toString()
                        }
                    })
                }
                // if(res.extraInfo.insureAttachAmount) res.insureAttachAmount = res.extraInfo.insureAttachAmount
                // if(res.extraInfo.insureAttachAmountCap) res.insureAttachAmountCap = res.extraInfo.insureAttachAmountCap
                // if(res.extraInfo.insureMainAmount) res.insureMainAmount = res.extraInfo.insureMainAmount
                // if(res.extraInfo.insureMainAmountCap) res.insureMainAmountCap = res.extraInfo.insureMainAmountCap
                // if(res.extraInfo.insureSumAmount) res.insureSumAmount = res.extraInfo.insureSumAmount
                // if(res.extraInfo.insureSumAmountCap) res.insureSumAmountCap = res.extraInfo.insureSumAmountCap
                // if(res.extraInfo.insureSumPay) res.insureSumPay = res.extraInfo.insureSumPay 
                // if(res.extraInfo.insureSumPayCap) res.insureSumPayCap = res.extraInfo.insureSumPayCap
            }
            if (res.productCode == 'OLD_INSURANCE_PROXY_SPECIAL_THIRD') {
                //特种设备第三者责任险特殊处理
                if (res.insuredList && res.insuredList.length > 0) {
                    res.contactName = res.insuredList[0].contactName || ''
                    res.contactPhone = res.insuredList[0].contactPhone || ''
                    res.address = res.insuredList[0].address || ''
                    res.zipCode = res.insuredList[0].zipCode || ''
                } else {
                    res.insuredList = [{}]
                }
            }
            //数字转字符串
            if (res.companyId) res.companyId = res.companyId.toString()
            // 游艇险数字转字符串
            if (res.extraInfo.shipInsuranceAmount) res.extraInfo.shipInsuranceAmount = res.extraInfo.shipInsuranceAmount.toString()
            if (res.extraInfo.shipInsuranceRate) res.extraInfo.shipInsuranceRate = res.extraInfo.shipInsuranceRate.toString()
            if (res.extraInfo.shipInsurancePremium) res.extraInfo.shipInsurancePremium = res.extraInfo.shipInsurancePremium.toString()
            if (res.extraInfo.threeInsuranceAmount) res.extraInfo.threeInsuranceAmount = res.extraInfo.threeInsuranceAmount.toString()
            if (res.extraInfo.threeInsuranceRate) res.extraInfo.threeInsuranceRate = res.extraInfo.threeInsuranceRate.toString()
            if (res.extraInfo.threeInsurancePremium) res.extraInfo.threeInsurancePremium = res.extraInfo.threeInsurancePremium.toString()
            if (res.extraInfo.insureSumPay) res.extraInfo.insureSumPay = res.extraInfo.insureSumPay.toString()
            // 特三数字转字符串
            if (res.extraInfo.massLossComAmount) res.extraInfo.massLossComAmount = res.extraInfo.massLossComAmount.toString()
            if (res.extraInfo.accidentComAmount) res.extraInfo.accidentComAmount = res.extraInfo.accidentComAmount.toString()
            if (res.extraInfo.casualtyComAmount) res.extraInfo.casualtyComAmount = res.extraInfo.casualtyComAmount.toString()
            if (res.extraInfo.diductible) res.extraInfo.diductible = res.extraInfo.diductible.toString()
            if (res.extraInfo.diductibleAmount) res.extraInfo.diductibleAmount = res.extraInfo.diductibleAmount.toString()
            if (res.extraInfo.everyoneComAmount) res.extraInfo.everyoneComAmount = res.extraInfo.everyoneComAmount.toString()
            if (res.extraInfo.comSumAmount) res.extraInfo.comSumAmount = res.extraInfo.comSumAmount.toString()
            if (res.extraInfo.insureRate) res.extraInfo.insureRate = res.extraInfo.insureRate.toString()

            // 国内产责/海外产责数字转字符串
            if (res.extraInfo.expectTotalSales) res.extraInfo.expectTotalSales = res.extraInfo.expectTotalSales.toString()
            if (res.extraInfo.prolossComAmount) res.extraInfo.prolossComAmount = res.extraInfo.prolossComAmount.toString()
            if (res.extraInfo.sumComAmount) res.extraInfo.sumComAmount = res.extraInfo.sumComAmount.toString()

            if (res.productCode == 'OLD_INSURANCE_PROXY_OVERSEAS_TRAVELERS') { //境外旅行人身意外伤害险
                //数字转字符串
                if (res.extraInfo.haveDeadBeneficiary == 0 || res.extraInfo.haveDeadBeneficiary == 1) {
                    res.extraInfo.haveDeadBeneficiary = res.extraInfo.haveDeadBeneficiary.toString()
                }
                if (res.insuredList && res.insuredList[0]) {
                    if (res.insuredList[0].gender) res.insuredList[0].gender = res.insuredList[0].gender.toString()
                }
            }
            if (res.effectiveTimeStart) res.effectiveTimeStart = res.effectiveTimeStart.toString()
            else res.effectiveTimeStart = '0'
            if (String(res.effectiveTimeEnd)){
                res.effectiveTimeEnd = String(res.effectiveTimeEnd)
            } else {
                res.effectiveTimeEnd = '24'
            }
            // 三证合一处理
            if (res.applicantList) {
                res.applicantList.forEach(el => {
                    if (typeof el.isThreeInOne == 'undefined') {
                        el.isThreeInOne = '1'
                    } else {
                        if (el.isThreeInOne) el.isThreeInOne = '1'
                        else el.isThreeInOne = '0'
                    }
                })
            }
            // 被保人，受益人 处理
            if (res.isInsuredApplicant == 1) res.isInsuredApplicant = '1'
            if (res.isInsuredApplicant == 0) res.isInsuredApplicant = '0'
            if (res.isBeneficiaryInsured == 1) res.isBeneficiaryInsured = '1'
            if (res.isBeneficiaryInsured == 0) res.isBeneficiaryInsured = '0'
            // if (res.insuredList&&res.insuredList.length>0) {
            // 	if(res.isInsuredApplicant)res.isInsuredApplicant='1'
            // 	else res.isInsuredApplicant='0'
            // } else {
            // 	res.isInsuredApplicant = ''
            // }
            if (res.beneficiaryList && res.beneficiaryList.length > 0) {
                res.everyAddress = res.beneficiaryList[0].address
            }
            if (!res.applicantList || res.applicantList.length == 0) res.applicantList = [{}]
            if (!res.beneficiaryList || res.beneficiaryList.length == 0) res.beneficiaryList = [{}]
            if (!res.insuredList || res.insuredList.length == 0) res.insuredList = [{}]

            if (res.productCode == 'OLD_INSURANCE_PROXY_YACHT') { //游艇险
                // 字符串转数组处理
                if (res.extraInfo.paymentAgree) res.extraInfo.paymentAgree = res.extraInfo.paymentAgree.split(',')
                if (res.extraInfo.specialAgree) res.extraInfo.specialAgree = res.extraInfo.specialAgree.split(',')
            }
            if (res.productCode == 'OLD_INSURANCE_PROXY_PRODUCT_LIABILITY_INLAND') { //国内产品责任险
                // 字符串转数组处理
                if (res.extraInfo.proAttachedData) res.extraInfo.proAttachedData = res.extraInfo.proAttachedData.split(',')
                if (res.extraInfo.paymentAgree) {
                    res.extraInfo.paymentAgree = res.extraInfo.paymentAgree.split(',')
                } else {
                    res.extraInfo.paymentAgree = ['1', '2', '3']
                }
                if (!res.extraInfo.isDeductible) res.extraInfo.isDeductible = '0'
                if (!res.extraInfo.solutionMethod) res.extraInfo.solutionMethod = '1'
            }
            if (res.productCode == 'OLD_INSURANCE_PROXY_PRODUCT_LIABILITY_FOREIGN') { //海外产品责任险
                // 字符串转数组处理
                if (res.extraInfo.proAttachedData) res.extraInfo.proAttachedData = res.extraInfo.proAttachedData.split(',')
                if (!res.extraInfo.isDeductible) res.extraInfo.isDeductible = '0'
            }
            // res.insureSumPay = res.premium
            console.log(res)
            resolve(res)
        })
    })
}

/**
 * 解决两个数相加精度丢失问题
 * @param a
 * @param b
 * @returns {Number}
 */
export const floatAdd = function (a, b) {
    var c, d, e;
    if (undefined == a || null == a || "" == a || isNaN(a)) { a = 0; }
    if (undefined == b || null == b || "" == b || isNaN(b)) { b = 0; }
    try {
        c = a.toString().split(".")[1].length;
    } catch (f) {
        c = 0;
    }
    try {
        d = b.toString().split(".")[1].length;
    } catch (f) {
        d = 0;
    }
    e = Math.pow(10, Math.max(c, d));
    return (floatMul(a, e) + floatMul(b, e)) / e;
}
/**
 * 解决两个数相减精度丢失问题
 * @param a
 * @param b
 * @returns {Number}
 */
export const floatSub = function (a, b) {
    var c, d, e;
    if (undefined == a || null == a || "" == a || isNaN(a)) { a = 0; }
    if (undefined == b || null == b || "" == b || isNaN(b)) { b = 0; }
    try {
        c = a.toString().split(".")[1].length;
    } catch (f) {
        c = 0;
    }
    try {
        d = b.toString().split(".")[1].length;
    } catch (f) {
        d = 0;
    }
    e = Math.pow(10, Math.max(c, d));
    return (floatMul(a, e) - floatMul(b, e)) / e;
}
/**
 * 解决两个数相乘精度丢失问题
 * @param a
 * @param b
 * @returns {Number}
 */
export const floatMul = function (a, b) {
    var c = 0,
        d = a.toString(),
        e = b.toString();
    try {
        c += d.split(".")[1].length;
    } catch (f) { }
    try {
        c += e.split(".")[1].length;
    } catch (f) { }
    return Number(d.replace(".", "")) * Number(e.replace(".", "")) / Math.pow(10, c);
}
/**
 * 解决两个数相除精度丢失问题
 * @param a
 * @param b
 * @returns
 */
export const floatDiv = function (a, b) {
    var c, d, e = 0,
        f = 0;
    try {
        e = a.toString().split(".")[1].length;
    } catch (g) { }
    try {
        f = b.toString().split(".")[1].length;
    } catch (g) { }
    return c = Number(a.toString().replace(".", "")), d = Number(b.toString().replace(".", "")), floatMul(c / d, Math.pow(10, f - e));
}



// WEBPACK FOOTER //
// ./src/common/agent.js